import * as React from 'react';
import {ThemeProvider} from '@mui/material/styles';
import {GridColDef} from '@mui/x-data-grid';
import {GridInitialStateCommunity} from '@mui/x-data-grid/models/gridStateCommunity';
import {flexeMuiTheme} from '../../shared/mui/default-mui-theme';
import {FlexeDataGrid} from '../../shared/mui/flexe-data-grid/FlexeDataGrid';
import {InventorySummary, UOMS} from './ItemMasterInterfaces';

interface InventorySummaryTableProps {
  summary: InventorySummary;
}

export function InventorySummaryTable({summary}: InventorySummaryTableProps) {
  const initialState: GridInitialStateCommunity = {};

  const rows = UOMS.map((uom, i) => {
    return {
      id: i,
      uom,
      stored: summary.stored[uom] ? summary.stored[uom] : 0,
      requested: summary.allocated[uom] ? summary.allocated[uom] : 0,
      inbounded: summary.received[uom] ? summary.received[uom] : 0,
      on_hold: summary.on_hold[uom] ? summary.on_hold[uom] : 0,
      damaged: summary.damaged[uom] ? summary.damaged[uom] : 0,
      available: summary.available[uom] ? summary.available[uom] : 0
    };
  }).filter(
    (row) =>
      row.stored > 0 ||
      row.requested > 0 ||
      row.inbounded > 0 ||
      row.on_hold > 0 ||
      row.damaged > 0 ||
      row.available > 0
  );

  return (
    <ThemeProvider theme={flexeMuiTheme}>
      <FlexeDataGrid
        sx={{}}
        slots={{}}
        columns={columns}
        rows={rows}
        loading={false}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        hideFooter={true}
        isRowSelectable={() => false}
        initialState={initialState}
      />
    </ThemeProvider>
  );
}

const columns: GridColDef[] = [
  {
    field: 'uom',
    headerName: 'UoM',
    type: 'string',
    valueFormatter: ({value}) => value?.toString(),
    flex: 1,
    align: 'left',
    headerAlign: 'left'
  },
  {
    field: 'stored',
    headerName: 'Stored',
    type: 'number',
    valueFormatter: ({value}) => value?.toString(),
    flex: 1,
    align: 'left',
    headerAlign: 'left'
  },
  {
    field: 'requested',
    headerName: "Req'd",
    type: 'number',
    valueFormatter: ({value}) => value?.toString(),
    flex: 1,
    align: 'left',
    headerAlign: 'left'
  },
  {
    field: 'inbounded',
    headerName: 'IB',
    type: 'number',
    valueFormatter: ({value}) => value?.toString(),
    flex: 1,
    align: 'left',
    headerAlign: 'left'
  },
  {
    field: 'on_hold',
    headerName: 'On Hold',
    type: 'number',
    valueFormatter: ({value}) => value?.toString(),
    flex: 1,
    align: 'left',
    headerAlign: 'left'
  },
  {
    field: 'damaged',
    headerName: 'DMGD',
    type: 'number',
    valueFormatter: ({value}) => value?.toString(),
    flex: 1,
    align: 'left',
    headerAlign: 'left'
  },
  {
    field: 'available',
    headerName: 'Avail.',
    type: 'number',
    valueFormatter: ({value}) => value?.toString(),
    flex: 1,
    align: 'left',
    headerAlign: 'left'
  }
];

export default InventorySummaryTable;
